// client/src/pages/Channels.jsx
import React, { useEffect, useState } from "react";
import StreamCard from "../components/StreamCard";

export default function ChannelsPage() {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadChannels() {
      try {
        setLoading(true);

        // 1) Get base channels list
        const res = await fetch("/api/channels");
        const data = await res.json();

        const baseChannels = Array.isArray(data)
          ? data
          : Array.isArray(data.channels)
          ? data.channels
          : [];

        // 2) Enrich with live status + last VOD from /api/streams/:slug
        const enriched = await Promise.all(
          baseChannels.map(async (ch) => {
            const slug = ch.slug || ch.id;

            try {
              const streamRes = await fetch(`/api/streams/${slug}`);
              const streamData = await streamRes.json();

              const player = streamData.player || {};
              const channelFromApi = streamData.channel || {};

              return {
                ...ch,
                isLive: !!player.live,
                lastVodPlaybackId:
                  channelFromApi.lastVodPlaybackId ||
                  ch.lastVodPlaybackId ||
                  null,
              };
            } catch (err) {
              console.error("Failed to load stream info for", slug, err);
              return ch;
            }
          })
        );

        if (!cancelled) {
          setChannels(enriched);
        }
      } catch (err) {
        console.error("Failed to load channels", err);
        if (!cancelled) {
          setChannels([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadChannels();

    // optional: refresh every 30s
    const interval = setInterval(loadChannels, 30000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="page channels-page">
      <h1 className="page-title">Channels</h1>

      {loading && <p className="channels-loading">Loading channels…</p>}

      <div className="channels-grid">
        {channels.map((channel) => (
          <StreamCard key={channel.id || channel.slug} channel={channel} />
        ))}
      </div>

      {!loading && channels.length === 0 && (
        <p className="channels-empty">No channels configured yet.</p>
      )}
    </div>
  );
}
